<script setup lang="ts">
defineProps({ blok: Object });

const items = ["ivoire", "ghana", "rest"];
</script>

<template>
  <section class="bg-chsc-yellow">
    <UiContainer>
      <div class="flex flex-wrap -mx-20">
        <div class="w-4/12 px-20 relative max-[769px]:w-full">
          <img
            :src="blok?.image.filename"
            :alt="blok?.image.alt"
            class="max-w-none h-full absolute top-0 right-0"
          />
        </div>
        <div class="w-8/12 px-20 py-20 max-[769px]:w-full">
          <div class="mb-8">
            <header
              class="[&>h4]:mb-6 [&>h4]:font-londrina-solid [&>h4]:text-chsc-indigo-500 [&>h4]:fs-4xl [&>p]:font-eb-garamond [&>p]:fs-2xl"
            >
              <StoryblokRichText :doc="blok?.header" />
            </header>
          </div>
          <div class="relative border-[2px] border-chsc-indigo-500 rounded-[40px] pt-12 pb-6 px-6">
            <h3
              class="absolute top-0 left-9 font-londrina-solid text-chsc-indigo-500 fs-4xl -translate-y-1/2 bg-chsc-yellow px-4"
            >
              {{ blok?.production_title }}
            </h3>
            <div class="flex flex-wrap -m-6">
              <div
                v-for="item in items"
                :key="item"
                class="relative w-1/3 p-6 flex flex-col items-center after:content-[''] after:absolute after:top-1/2 after:-translate-y-1/2 after:left-0 after:w-px after:h-[75%] after:bg-chsc-indigo-500 first:after:hidden max-[641px]:w-full max-[641px]:after:hidden max-[641px]:border-b max-[641px]:last:border-none"
              >
                <h5 class="mb-3 font-londrina-solid text-white fs-3xl">
                  {{ blok?.[`production_${item}_label`] }}
                </h5>
                <p class="font-londrina-solid text-chsc-indigo-500 fs-2xl">
                  {{ blok?.year1 }}
                </p>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="18" height="18" fill="#360086" />
                </svg>
                <p class="fs-8xl font-londrina-solid text-white">
                  {{ blok?.[`production_${item}_data`] }}%
                </p>
                <svg
                  width="39"
                  height="38"
                  viewBox="0 0 39 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 -1.26763e-06L28.5 -4.5897e-07L28.5 20.5L39 20.5L18.5 37.5L0.499999 20.5L10 20.5L10 -1.26763e-06Z"
                    fill="#360086"
                  />
                </svg>
                <p class="font-londrina-solid text-chsc-indigo-500 fs-2xl">
                  {{ blok?.year2 }}
                </p>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="18" height="18" fill="#360086" />
                </svg>
                <p class="fs-8xl font-londrina-solid text-white">
                  {{ blok?.[`production_${item}_data_2025`] }}%
                </p>
                <svg
                  width="39"
                  height="38"
                  viewBox="0 0 39 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 -1.26763e-06L28.5 -4.5897e-07L28.5 20.5L39 20.5L18.5 37.5L0.499999 20.5L10 20.5L10 -1.26763e-06Z"
                    fill="#360086"
                  />
                </svg>
                <p class="font-londrina-solid text-chsc-indigo-500 fs-2xl">
                  {{ blok?.year3 }}
                </p>
              </div>
            </div>
          </div>
          <div>
            <div class="mt-8">
              <header
                class="[&>h4]:mb-6 [&>h4]:font-londrina-solid [&>h4]:text-chsc-indigo-500 [&>h4]:fs-4xl [&>p]:font-eb-garamond [&>p]:fs-2xl"
              >
                <StoryblokRichText :doc="blok?.bottom_description" />
              </header>
            </div>
          </div>
        </div>
      </div>
    </UiContainer>
  </section>
</template>
